import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { SessionService } from '@common/services/session.service';
import { environment } from '@environments/environment.dev';
import { AuthService } from '@modules/auth/services/auth.service';

export default function tokenValidator(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);

  if(sessionService.value){
    if(isTimeToRefreshTokenExpired(sessionService.value as string)){
      sessionService.refreshToken();
    }

    if(isTokenExpired(sessionService.value as string)){
      authService.logout();
    }
  }

  return next(req);
}

function isTimeToRefreshTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    const timeToExpire = payload.exp - now;

    return timeToExpire > 0 && timeToExpire <= environment.timeToRefreshToken;
  } catch (e: any) {
    console.log(e);
    return true;
  }
}

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    const timeToExpire = payload.exp - now;

    return timeToExpire < 0;
  } catch (e: any) {
    console.log(e);
    return true;
  }
}


